module.exports = __webpack_public_path__ + "img/time.19bec7f9.svg";